/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import {
    TokenV2ResponseChallengeList,
    instanceOfTokenV2ResponseChallengeList,
    TokenV2ResponseChallengeListFromJSON,
    TokenV2ResponseChallengeListFromJSONTyped,
    TokenV2ResponseChallengeListToJSON,
} from './TokenV2ResponseChallengeList';
import {
    TokenV2ResponseToken,
    instanceOfTokenV2ResponseToken,
    TokenV2ResponseTokenFromJSON,
    TokenV2ResponseTokenFromJSONTyped,
    TokenV2ResponseTokenToJSON,
} from './TokenV2ResponseToken';

/**
 * @type TokenV2Response
 * 
 * @export
 */
export type TokenV2Response = { type: 'challenge_list' } & TokenV2ResponseChallengeList | { type: 'token' } & TokenV2ResponseToken;

export function TokenV2ResponseFromJSON(json: any): TokenV2Response {
    return TokenV2ResponseFromJSONTyped(json, false);
}

export function TokenV2ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenV2Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'challenge_list':
            return {...TokenV2ResponseChallengeListFromJSONTyped(json, true), type: 'challenge_list'};
        case 'token':
            return {...TokenV2ResponseTokenFromJSONTyped(json, true), type: 'token'};
        default:
            throw new Error(`No variant of TokenV2Response exists with 'type=${json['type']}'`);
    }
}

export function TokenV2ResponseToJSON(value?: TokenV2Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'challenge_list':
            return TokenV2ResponseChallengeListToJSON(value);
        case 'token':
            return TokenV2ResponseTokenToJSON(value);
        default:
            throw new Error(`No variant of TokenV2Response exists with 'type=${value['type']}'`);
    }

}

